import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    viewContainer: {
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        color: ({ theme }) => theme.palette.text.primary,
        textAlign: "start",
    },
    titles: {
        textAlign: 'justify',
        fontWeight: '600',
        padding: '5px 0 0 5px',
    },
    text: {
        color: ({ theme }) => theme.palette.text.primary,
        fontSize: "16px",
        width: '50%'
    },
    btn: {
        color: ({ theme }) => theme.palette.mode === 'light' ? "#9a0143" : "#fff",
        fontFamily: 'Rubik',
        '&:hover': {
            backgroundColor: ({ theme }) => theme.palette.mode === 'light' ? 'rgba(128, 128, 128, 0.2)' : "#9a0143",
        }
    },
    popup: {
        display: 'flex',
        justifyContent: 'center',
    },
    btnWrapper: {
        display: 'flex',
        justifyContent: 'center',
        gap: '10%'
    },
    multiline: {
        whiteSpace: 'pre-line'
    },
    fontBold: {
        fontWeight: '600'
    },
    roleWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginTop: "1%",
    },
    back: {
        float: "right",
        width: "100px",
        height: "37px",
        background: "#5B5D6E",
        fontFamily: "Rubik",
        fontSize: "12px",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#5B5D6E",
        },
    },
    pageWrapper: {
        width: "100%",
        backgroundColor: ({ theme }) => theme.palette.bgColor,
        boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
        borderRadius: "10px",
        paddingInline: "20px",
        fontFamily: "Rubik",
        paddingBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
    },
    titleWrapper: {
        width: "100%",
        marginBottom: "13px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    transferSection: {
        width: "100%",
    },
    userDetailsWrapper: {
        display: "flex",
        flexDirection: "row",
        gap: "100px",
        width: "100%"
    },
    saveBtnWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
    },
    saveBtn: {
        backgroundColor: "#9A0143",
        color: "#fff",
        marginTop: "10px",
        fontFamily: "Rubik",
        fontSize: "12px",
        "&:hover": {
            backgroundColor: "#9A0143",
        },
    },
    actionWrapper: {
        display: "flex",
        gap: "10px",
        alignItems: "center",
    },
    divider: {
        margin: "2rem 0 1rem 0",
        borderBottomWidth: 2,
        width: '100%'
    },
    details: {
        fontSize: "14px",
        fontFamily: "inherit",
        fontWeight: 400,
        color: ({ theme }) => theme.palette.text.primary,
        lineHeight: "200%",
    },
    userPermissionsWrapper: {
        display: "flex",
        flexDirection: "row",
        gap: "30px",
        width: "100%",
        backgroundColor: "#b3b3b390",
        borderRadius: "10px",
    },
    info: {
        textAlign: 'justify',
        marginBottom: '10px',
        marginTop: '10px',
        fontStyle: "italic",
        padding: '0 5px 5px 5px',
        color: ({ theme }) => theme.palette.text.primary,
        background: "rgba(154, 1, 67, 0.1)",
    },
    addRoleButton: {
        background: "#9A0143",
        fontFamily: "Rubik",
        fontSize: "12px",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#9A0143",
        },
    },
    loadingContainer: {
        marginTop: "10%",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "70vh"
    },
})